import React, { useEffect, useState } from "react";

function RelatorioLocatarios() {
  const [locatarios, setLocatarios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch("/api/locatarios", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLocatarios(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Erro ao buscar locatários:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-bold text-blue-600 mb-4">Relatório de Locatários</h2>

      {loading ? (
        <p>Carregando dados...</p>
      ) : locatarios.length === 0 ? (
        <p>Nenhum locatário encontrado.</p>
      ) : (
        <table className="w-full bg-white shadow rounded">
          <thead className="bg-gray-200 text-gray-700">
            <tr>
              <th className="p-3 text-left">Nome</th>
              <th className="p-3 text-left">CPF/CNPJ</th>
              <th className="p-3 text-left">Imóvel</th>
              <th className="p-3 text-left">Início do Contrato</th>
              <th className="p-3 text-left">Fim do Contrato</th>
              <th className="p-3 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {locatarios.map((item) => (
              <tr key={item.id} className="border-t">
                <td className="p-3">{item.nome}</td>
                <td className="p-3">{item.documento}</td>
                <td className="p-3">{item.imovel}</td>
                <td className="p-3">{item.inicio_contrato}</td>
                <td className="p-3">{item.fim_contrato}</td>
                <td className="p-3 text-green-600">{item.ativo ? "Ativo" : "Inativo"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default RelatorioLocatarios;
